import React, { useState } from 'react'
import { Popover, ArrowContainer } from 'react-tiny-popover'
import { Stack, Flex, Text } from '../../vanilla'
import { CloseIcon, InfoIcon } from '../icons'
import { baseThemeContract } from '../../vanilla/vars.css'
import { isMobile } from '../../utils/utils'
import { sponsoredPopoverLink } from './styles.css'

export const SponsoredProductPopover = () => {
  const [sponsoredProductsPopoverIsOpen, setSponsoredProductsPopoverIsOpen] = useState(false)

  return (
    <>
      <Popover
        positions={['top']}
        align="center"
        reposition={true}
        containerStyle={{ zIndex: baseThemeContract.zIndex.popover }}
        onClickOutside={() => setSponsoredProductsPopoverIsOpen(false)}
        isOpen={sponsoredProductsPopoverIsOpen}
        content={({ position, childRect, popoverRect }) => (
          <ArrowContainer
            position={position}
            childRect={childRect}
            popoverRect={popoverRect}
            arrowColor="white"
            arrowSize={10}
            arrowStyle={{ zIndex: baseThemeContract.zIndex.popover }}
          >
            <Stack
              spacing="16px"
              paddingX="20px"
              paddingTop="20px"
              paddingBottom="32px"
              bg="white"
              style={{
                maxWidth: isMobile() ? "100vw" : 420,
                width: isMobile() ? "calc(100vw - 20px)" : "auto",
                boxShadow: "0 10px 25px 0 rgb(0 0 0 / 40%)",
              }}
              className="sponsored-product-popover"
            >
              <Flex align="center" justify="space-between" gap="4px">
                <Text variant="text6">Sponsored</Text>
                <CloseIcon marginLeft="8px" boxSize="30px" onClick={() => setSponsoredProductsPopoverIsOpen(false)} />
              </Flex>
              <Text variant="text3" lineHeight="short">
                Certain items may appear more prominently in search results or category listings because of advertising or promotional agreements with suppliers.{' '}
                <Text 
                  as='a' 
                  href='/terms.html#sponsored-products' 
                  className={sponsoredPopoverLink}
                >
                  Learn More
                </Text>
              </Text>
            </Stack>
          </ArrowContainer>
        )}
      >
      <InfoIcon 
        boxSize="12px"
        className='sponsored-product-popover'
        cursor='pointer'
        onClick={() => setSponsoredProductsPopoverIsOpen(!sponsoredProductsPopoverIsOpen)}
        />
      </Popover>
    </>
  )
}